import { Box, get, Theme } from "theme-ui";

import { GradientBoxProps } from "./GradientBox.d";

export const GradientBox: React.FC<GradientBoxProps> = ({
  active = true,
  colors,
  children,
  onClick,
}) => {
  const getColor = (theme: Theme) => {
    if (!active) return get(theme, "colors.greyMedium");
    const themeColors = colors.map((c) => get(theme, `colors.${c}`));
    return `linear-gradient(to right, ${themeColors.join(",")})`;
  };
  return (
    <Box
      onClick={onClick}
      sx={{
        width: "100%",
        height: "100%",
        p: 1,
        mb: 5,
        borderRadius: 3,
        boxShadow: active ? 1 : "none",
        background: getColor,
      }}
    >
      <Box
        sx={{
          p: 1,
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "white",
          height: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
